  import { Injectable } from '@angular/core';
  import { BehaviorSubject } from 'rxjs';

  @Injectable({
    providedIn: 'root'
  })
  export class GlobalService {
    openSignInModal = new BehaviorSubject<boolean>(false);
    openDemoModal = new BehaviorSubject <boolean>(false);
    openSignupModal = new BehaviorSubject <boolean>(false);

    menuIndex = new BehaviorSubject<number>(0);

    constructor() { }

    sendOpenSignInModal(data: any) {
      this.openSignInModal.next(data);
    }

    getOpenSignInModal() {
      return this.openSignInModal.asObservable();
    }
    getOpenSignUpModal() {
      return this.openSignupModal.asObservable();
    }
    getOpenDemoModel() {
      return this.openDemoModal.asObservable();

    }
    sendMenuIndex(data: any) {
      this.menuIndex.next(data);
    }

    getMenuIndex() {
      return this.menuIndex.asObservable();
    }
  }
